<div class=" contact-us">
    <div class=" pt-100">
        <div class="text-center">
            <h1 class="fs-36">REQUEST FOR DEMO</h1>
            <!-- <p>We love to hear from you!</p> -->
        </div>
        <div class="pt-5 text-center">
            <h1>Submit your details</h1>
        </div>
        <div class="container" fxLayout="column">
            <div class="row justify-content-center">
                <div class="col-12 col-md-5 box">
                    <form [formGroup]="registerDemoForm" autocomplete="off" fxLayout.xs="column">

                        <mat-form-field class="w-100 ">
                            <mat-label>Name</mat-label>
                            <input matInput formControlName="name" required maxlength="35" allowValues
                                isInputType="onlyChar">
                            <mat-error *ngIf="registerDemoForm.get('name').hasError('required')">
                                Please enter name
                            </mat-error>
                        </mat-form-field>
                        <p class="placeholder-label">Phone Number
                            <span
                                [ngClass]="{'placeholder-label-required' : (registerDemoForm.get('phone').hasError('required') && businessPhoneValue.touched) }">*</span>
                        </p>
                        <mat-form-field class="w-100 country-flag-txt">
                            <input matInput countryFlagPhone allowValues isInputType="phone" formControlName="phone"
                                required>
                            <mat-error *ngIf="registerDemoForm.get('phone').hasError('required')">
                                Please enter phone number
                            </mat-error>
                            <mat-error *ngIf="!registerDemoForm.get('phone').hasError('required') && 
                                        registerDemoForm.get('phone').hasError('isInvalid')">
                                Please enter valid phone number
                            </mat-error>
                            <!-- <input matInput hidden="true" />
                            <ngx-intl-tel-input [cssClass]="'custom'" [preferredCountries]="preferredCountries"
                                [enableAutoCountrySelect]="false" [enablePlaceholder]="true" [searchCountryFlag]="true"
                                [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
                                [selectFirstCountry]="true" [selectedCountryISO]="selectedCountry" [maxLength]="15"
                                [phoneValidation]="true" [separateDialCode]="separateDialCode" name="phone"
                                formControlName="phone">
                            </ngx-intl-tel-input>
                            <mat-hint
                                *ngIf="registerDemoForm.get('phone').hasError('required') && businessPhoneValue.touched">
                                Please enter phone number
                            </mat-hint>
                            <mat-hint
                                *ngIf="!registerDemoForm.get('phone').hasError('required') && 
                            (businessPhoneValue.invalid || (businessPhoneValue.touched && businessPhoneValue.invalid))">
                                Please enter valid phone number
                            </mat-hint> -->
                        </mat-form-field>
                        <mat-form-field class="w-100 ">
                            <mat-label>Email</mat-label>
                            <input matInput formControlName="email" required maxlength="255">
                            <mat-error *ngIf="registerDemoForm.get('email').hasError('required')">
                                Please enter email
                            </mat-error>
                            <mat-error
                                *ngIf="registerDemoForm.get('email').hasError('email') || registerDemoForm.get('email').hasError('pattern')">
                                Please enter valid email
                            </mat-error>
                        </mat-form-field>
                        <mat-form-field class="w-100">
                            <mat-label>Organization Name</mat-label>
                            <input allowValues isInputType="alphaNumeric" matInput formControlName="organization_name">
                        </mat-form-field>
                        <p class="pt-10 mb-5">By clicking the button, you agree to the <a target="_blank"
                                routerLink="/termsandconditions">Terms and Conditions.</a></p>
                        <p>Click <a target="_blank" routerLink="/privacypolicy">Here </a>to read {{clientDetails.name}}'s Privacy
                            Policy.</p>
                        <div class="text-center mt-20">
                            <button mat-flat-button color="primary" class="flat-secondary-button"
                                (click)="onSubmit()">Submit</button>
                        </div>
                    </form>
                </div>
            </div>

        </div>


    </div>
</div>